import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-tertiary-button",
  template: `
    <button>
      {{ label }}
    </button>
  `,
  styles: [
    `
      button {
        border: none;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        font-family: Karla;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 16px;
        text-align: center;
        border: 2px solid #efefef;
        border-radius: 8px;
        color: #606060;
      }
    `,
    `
      button:focus {
        outline: none !important;
      }
    `,
    `
      button:hover {
        background: #efefef;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.23);
      }
    `,
    `
      button:active {
        background: #cfcfcf;
        color: #606060;
      }
    `,
    `
      button.large {
        background: #b05713;
        flex: 1 0 100%;
      }
    `,
    `
      button.small {
        font-size: 12px;
        line-height: 12px;
      }
    `,
    `
      .icon {
        background: #b05713;
        box-shadow: 0px 2px 4px transparent;
        font-size: 12px;
        line-height: 12px;
      }
    `
  ]
})
export class TertiaryButtonComponent implements OnInit {
  @Input() label: string = "rest";
  constructor() {}

  ngOnInit(): void {}
}
